import { NO_MESSAGES_FOR_FILTER_TEST_ID, NO_MESSAGES_TEST_ID } from '../../constants';
import { Empty } from 'antd';

import styles from './inboxV2List.module.less';

type InboxPageV2NoMessagePlaceholderProps = {
	hasFilter: boolean;
};

function EmptyIcon() {
	return (
		<svg
			width="184"
			height="117"
			viewBox="0 0 184 117"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M25.875 83C9.85688 86.5947 0 91.4916 0 96.8884C0 107.921 41.1898 116.864 92 116.864C142.81 116.864 184 107.921 184 96.8884C184 91.4916 174.143 86.5947 158.125 83V91.708C158.125 97.7664 154.33 102.732 149.644 102.732H34.3563C29.67 102.732 25.875 97.7635 25.875 91.708V83Z"
				fill="black"
				fill-opacity="0.06"
			/>
			<path
				d="M119.637 48.3152C119.637 43.7351 122.495 39.954 126.04 39.9512H158.125V91.708C158.125 97.7663 154.33 102.732 149.644 102.732H34.3562C29.67 102.732 25.875 97.7634 25.875 91.708V39.9512H57.96C61.5049 39.9512 64.3626 43.7266 64.3626 48.3067V48.3695C64.3626 52.9496 67.252 56.6479 70.794 56.6479H113.206C116.748 56.6479 119.637 52.9153 119.637 48.3352V48.3152Z"
				fill="black"
				fill-opacity="0.04"
				stroke="black"
				stroke-opacity="0.15"
			/>
			<path
				d="M158.125 40.2662L128.955 7.44342C127.555 5.20615 125.511 3.85352 123.358 3.85352H60.6424C58.489 3.85352 56.4449 5.20615 55.0448 7.44056L25.875 40.2691"
				stroke="black"
				stroke-opacity="0.15"
			/>
		</svg>
	);
}

/**
 * Placeholder for when there are no messages in the inbox, either because there are no messages or because the current filter options don't match any messages.
 */
export default function InboxPageV2NoMessagePlaceholder({
	hasFilter,
}: InboxPageV2NoMessagePlaceholderProps) {
	return (
		<div className={styles.noMessageWrapper}>
			<Empty
				image={<EmptyIcon />}
				description={
					hasFilter ? (
						<div
							data-testid={NO_MESSAGES_FOR_FILTER_TEST_ID}
							className={styles.emptyDescription}
						>
							No messages found for the current filtering options
						</div>
					) : (
						<div data-testid={NO_MESSAGES_TEST_ID} className={styles.emptyDescription}>
							No messages found
						</div>
					)
				}
			/>
		</div>
	);
}
